// Search utility functions

const searchInServices = (query, services) => {
  if (!services) return [];
  
  const results = [];
  const serviceKeys = ['shareholder', 'client', 'supplier', 'team', 'training'];
  
  serviceKeys.forEach((key) => {
    const service = services[key];
    if (!service) return;
    
    const titleMatch = service.title?.toLowerCase().includes(query);
    const descMatch = service.description?.toLowerCase().includes(query);
    
    if (titleMatch || descMatch) {
      results.push({
        id: key,
        type: 'service',
        title: service.title,
        description: service.description,
        section: 'services'
      });
    }
  });
  
  return results;
};

const searchInTeam = (query, team) => {
  if (!team?.members) return [];
  
  return team.members
    .filter((member) => {
      const nameMatch = member.name?.toLowerCase().includes(query);
      const bioMatch = member.bio?.toLowerCase().includes(query);
      return nameMatch || bioMatch;
    })
    .map((member) => ({
      id: member.name,
      type: 'team',
      title: member.name,
      description: member.role,
      section: 'team'
    }));
};

const searchInFAQ = (query, faq) => {
  if (!faq?.items) return [];
  
  return faq.items
    .filter((item) => {
      const questionMatch = item.question?.toLowerCase().includes(query);
      const answerMatch = item.answer?.toLowerCase().includes(query);
      return questionMatch || answerMatch;
    })
    .map((item, index) => ({
      id: `faq-${index}`,
      type: 'faq',
      title: item.question,
      description: item.answer.substring(0, 100) + '...',
      section: 'faq'
    }));
};

const searchInValues = (query, values) => {
  if (!values) return [];
  
  return Object.entries(values)
    .filter(([, value]) => {
      const titleMatch = value.title?.toLowerCase().includes(query);
      const descMatch = value.description?.toLowerCase().includes(query);
      return titleMatch || descMatch;
    })
    .map(([key, value]) => ({
      id: key,
      type: 'value',
      title: value.title,
      description: value.description,
      section: 'about'
    }));
};

export const searchContent = (query, translations) => {
  if (!query.trim()) return [];
  
  const lowerQuery = query.toLowerCase();
  
  return [
    ...searchInServices(lowerQuery, translations.services),
    ...searchInTeam(lowerQuery, translations.team),
    ...searchInFAQ(lowerQuery, translations.faq),
    ...searchInValues(lowerQuery, translations.about?.values)
  ];
};
